import type { ApiErrorBody } from "@chotca/config";

export class ChotcaApiError extends Error {
  readonly name = "ChotcaApiError";

  constructor(
    public readonly code: string,
    message: string,
    public readonly status: number,
    public readonly details?: Record<string, unknown>,
    public readonly requestId?: string,
  ) {
    super(message);
  }

  static fromBody(body: ApiErrorBody, status: number): ChotcaApiError {
    return new ChotcaApiError(
      body.code,
      body.message,
      status,
      body.details,
      body.requestId,
    );
  }
}
